import React from 'react'
import Link from 'next/link'
import { Alert, AlertTitle, Snackbar, type SnackbarCloseReason } from '@mui/material'
import { useStore } from '@/src/types/store'

const GlobalToast = () => {
  const { toastOpen, toastMessage, toastType, toastDuration, toastTitle, toastAction, closeToast } =
    useStore()

  // A toast with no timer holds something the user has to act on, so a stray click must not lose it.
  const handleClose = (_: unknown, reason: SnackbarCloseReason) => {
    if (reason === 'clickaway' && toastDuration === null) return
    closeToast()
  }

  return (
    <Snackbar
      open={toastOpen}
      autoHideDuration={toastDuration}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
    >
      <Alert
        onClose={closeToast}
        severity={toastType}
        variant="filled"
        className={toastTitle ? 'max-w-[26.25rem]' : ''}
        sx={{ width: '100%', bgcolor: toastTitle ? 'info.dark' : undefined }}
      >
        {toastTitle && (
          <AlertTitle sx={{ color: 'inherit', fontSize: '0.875rem', fontWeight: 600 }}>
            {toastTitle}
          </AlertTitle>
        )}
        {toastMessage}
        {toastAction && (
          <Link
            href={toastAction.href}
            onClick={closeToast}
            className="block mt-1 font-semibold text-white underline"
          >
            {toastAction.label}
          </Link>
        )}
      </Alert>
    </Snackbar>
  )
}

export default GlobalToast
